import { REDUCER_NAME } from './const'
import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../../const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const UPLOAD_CSV_REQUEST = NS + 'UPLOAD_CSV_REQUEST'
export const UPLOAD_CSV_SUCCESS = NS + 'UPLOAD_CSV_SUCCESS'
export const UPLOAD_CSV_ERROR = NS + 'UPLOAD_CSV_ERROR'



// WEBPACK FOOTER //
// ./src/modules/foil/state/overview/csv-upload/type.js